import React from "react";
import styled from "styled-components";
import { LifeAtBodySecondary } from "@common/LifeAtText/LifeAtText";

const Container = styled.div`
    display: flex;
    flex-direction: column;
    text-align: center;
    gap: 10px;
    padding: 15px;
    align-items: center;
`;

const Image = styled.img`
    width: 300px;
    height: auto;
    margin-top: 10px;
`;

const StyledBodyText = styled(LifeAtBodySecondary)`
    width: 240px;
`;

const TASK_TO_CALENDAR_IMG_URL =
    "https://firebasestorage.googleapis.com/v0/b/lifeatspaces-prod.appspot.com/o/images%2FtaskToTimer%2Ftask-to-calendar.png?alt=media&token=c76ece06-0489-4a40-988d-8ea0164a4c5c";
const INFO_LABEL = "Assign a duration to a task by dragging it to your calendar and click the play button";
interface TaskTimerPlaceholderProps {}
export default function TaskTimerPlaceholder(props: TaskTimerPlaceholderProps) {
    return (
        <Container>
            <Image src={TASK_TO_CALENDAR_IMG_URL} />
            <StyledBodyText>{INFO_LABEL}</StyledBodyText>
        </Container>
    );
}
